<template>
  <v-container v-if="isVenueSettings">

    <v-layout pt-2 pb-2>
      <v-flex>
        <v-form action.prevent="">
          <v-card>
            <v-card-title>
              <span class="title font-weight-light">Venue Book-hotel section settings</span>
            </v-card-title>

            <v-layout row wrap>
              <v-flex xs6 px-2 class="mb-5">
                <v-card width="320">
                  <div class="grey lighten-2">
                    <v-card-media height="130" :src="bannerImageUrl"/>
                  </div>
                  <v-card-title><h3>Background Image</h3></v-card-title>
                  <v-card-actions>
                    <v-btn flat color="success" @click="setImageFor('imageUrl')">Choose</v-btn>
                    <v-btn flat color="error"
                           @click="resetImage('imageUrl')">Reset
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>

              <v-flex xs6 px-2 class="mb-5">
                <v-card width="320">
                  <div class="grey lighten-2">
                    <v-card-media height="130" :src="logoImageUrl"/>
                  </div>
                  <v-card-title><h3>Logo</h3></v-card-title>
                  <v-card-actions>
                    <v-btn flat color="success" @click="setImageFor('imageAlternativeUrl')">Choose</v-btn>
                    <v-btn flat color="error"
                           :disabled="!formData.imageAlternativeUrl"
                           @click="resetImage('imageAlternativeUrl')">Reset
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>

            </v-layout>

            <v-layout row wrap>
              <v-flex xs6 px-2 class="mb-5">
                <content-editor
                  label="drop-down title"
                  v-model="formData.title"
                  @input="$v.formData.title.$touch()"
                  @blur="$v.formData.title.$touch()"
                  :error="$v.formData.title"
                />
              </v-flex>

              <v-flex xs6 px-2 class="mb-5">
                <content-editor
                  label="drop-down subtitle"
                  v-model="formData.description"
                  @input="$v.formData.description.$touch()"
                  @blur="$v.formData.description.$touch()"
                  :error="$v.formData.description"
                />
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs4 px-2 class="mb-5">
                <v-text-field
                  class="input"
                  v-model="formData.buttonText"
                  name="open-button"
                  label="Open button"
                />
              </v-flex>

              <v-flex xs4 px-2 class="mb-5">
                <v-text-field
                  class="input"
                  v-model="formData.buttonAlternativeText"
                  name="drop-down-button"
                  label="Button inside drop-down"
                />
              </v-flex>

              <v-flex xs4 px-2 class="mb-5">
                <v-text-field
                  class="input"
                  v-model="formData.buttonUrl"
                  name="button-link"
                  label="Link for button inside drop-down"
                />
              </v-flex>
            </v-layout>
            <v-layout justify-end>
              <v-btn
                class="btn_submit"
                color="success"
                @click="submitForm"
                :disabled="$v.$invalid"
              >Update settings
              </v-btn>
            </v-layout>
            <div>
              <v-dialog v-model="modalGallery">
                <galleries-list :modalView="true" @pickedImage="setImage"/>
              </v-dialog>
            </div>

          </v-card>
        </v-form>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
  import GalleriesList from '@/components/pages/Gallery/GalleriesList'
  import { required, url } from 'vuelidate/lib/validators'
  import { mapGetters, mapActions } from 'vuex'
  import { clone, isNil, pathOr } from 'ramda'

  export default {
    name: "BookHotel",
    components: {
      GalleriesList
    },
    data () {
      return {
        formData: {
          description: '',
          title: '',
          imageUrl: '',
          buttonText: '',
          buttonAlternativeText: '',
          imageAlternativeUrl: '',
          buttonUrl: ''
        },
        imagePath: '',
        modalGallery: false
      }
    },
    validations: {
      formData: {
        description: { required },
        title: { required },
        imageUrl: { required, url },
        buttonText: { required },
        buttonAlternativeText: { required },
        imageAlternativeUrl: { required, url },
        buttonUrl: { required, url }
      }
    },
    watch: {
      venueSettings () {
        this.setFormData()
      }
    },
    computed: {
      ...mapGetters([
        'venueSettings'
      ]),
      bannerImageUrl () {
        return pathOr('', ['imageUrl'], this.formData)
      },
      logoImageUrl () {
        return pathOr('', ['imageAlternativeUrl'], this.formData)
      },
      isVenueSettings () {
        return !isNil(this.venueSettings)
      }
    },
    methods: {
      ...mapActions([
        'updateBookHotelSettings'
      ]),
      setImageFor (path) {
        this.imagePath = path
        this.toggleModal ()
      },
      toggleModal () {
        this.modalGallery = !this.modalGallery
      },
      resetImage (path) {
        this.formData[path] = ''
      },
      setImage (item) {
        this.formData[this.imagePath] = item.imagesUrls.originalImageUrl
        this.toggleModal()
      },
      setFormData () {
        this.formData = clone(this.venueSettings)
      },
      submitForm () {
        this.$v.$touch()
        if (this.$v.$invalid) return
        this.updateBookHotelSettings(this.formData)
      }
    },
    created() {
      if(this.isVenueSettings) {
        this.setFormData ()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Venue/BookHotel.vue